import React, { useState, useEffect } from 'react';
import { useObserver } from 'mobx-react';
import { Box } from '@mui/material';
import { useOutletContext, useNavigate } from 'react-router-dom';
import Hero from '../components/hero';
import Featured from './featured';
import WhatsHot from './whatshot';
import Recommended from './recommended';
import Trending from './trending';
import NearMe from './nearme';
import Directory from './directory';
import SectionAnchor from '../components/sectionAnchor';
import useScrollToHash from './useScrollToHash';
import usePublisherInit from '../../store/models/publisher/usePublisherInit';
import { usePublisherStore } from '../../store/models/publisher';

function WorldPage() {
    const { subscriber, onSync, onShare } = useOutletContext();
    const publisherStore = usePublisherStore();
    const navigate = useNavigate();
    const [totalSubscribers, setTotalSubscribers] = useState(null);
    usePublisherInit();
    useScrollToHash();

    // getTotalSubscribers() is fired once from usePublisherInit() above,
    // fire-and-forget alongside the other publisher fetches — not polled.
    const signals = useObserver(() => ({
        totalSubscribers: publisherStore.observed.totalSubscribers,
        // Read raw (not a uuid token) — booleans are reactive as-is.
        totalSubscribersLoading: publisherStore.observed.totalSubscribersLoading,
    }));

    useEffect(() => {
        setTotalSubscribers(publisherStore.totalSubscribers);
    }, [signals.totalSubscribers]);

    function handleBrowse() {
        navigate('/#directory');
    }

    function handleWhatsHot() {
        navigate('/#whats-hot');
    }

    return (
        <Box>
            <Hero
                onBrowse={handleBrowse}
                onWhatsHot={handleWhatsHot}
                totalSubscribers={totalSubscribers}
                totalSubscribersLoading={signals.totalSubscribersLoading}
            />

            <SectionAnchor id="featured" />
            <Featured onSync={onSync} onShare={onShare} />

            <SectionAnchor id="whats-hot" />
            <WhatsHot onSync={onSync} onShare={onShare} />

            <Recommended subscriber={subscriber} onSync={onSync} onShare={onShare} />

            <Trending subscriber={subscriber} onSync={onSync} onShare={onShare} />

            <SectionAnchor id="near-you" />
            <NearMe onSync={onSync} onShare={onShare} />

            <SectionAnchor id="directory" />
            <Directory onSync={onSync} onShare={onShare} />
        </Box>
    );
}

export default WorldPage;
